/* Minimal pub/sub used by recipient-form.js (the theme shipped the form script without it). */
window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
if (typeof window.subscribe !== 'function') {
  window.__pubsubSubscribers = {};
  window.subscribe = function (eventName, callback) {
    var subs = window.__pubsubSubscribers;
    if (subs[eventName] === undefined) subs[eventName] = [];
    subs[eventName].push(callback);
    return function unsubscribe() {
      subs[eventName] = subs[eventName].filter(function (cb) { return cb !== callback; });
    };
  };
  window.publish = function (eventName, data) {
    var subs = window.__pubsubSubscribers;
    if (subs[eventName]) subs[eventName].forEach(function (cb) { cb(data); });
  };
}
